import RequestHandler from "./request-handler";
class SwissConstantService {
    constructor() {
        this.path = "SwissConstant";
        if (SwissConstantService.instance) {
            return SwissConstantService.instance;
        }
        SwissConstantService.instance = this;
        return this;
    }
    async get() {
        return await RequestHandler.get(this.path);
    }
    async insert(data) {
        return await RequestHandler.post(this.path, data);
    }
    async update(data) {
        return RequestHandler.put(this.path, data);
    }
    async delete(id) {
        return await RequestHandler.delete(this.path, id);
    }
    async import(data) {
        return await RequestHandler.import(this.path, data);
    }
}
const instance = new SwissConstantService();
export default instance;